

















import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'DataTreeElement',
  props: {
    element: {
      required: true
    }
  },
  emits: ['label-click'],
  setup(props, { emit }) {
    const expanded = ref(false)
    const selected = ref(false)

    const toggle = () => {
      expanded.value = !expanded.value
    }

    const labelClick = (element: any) => {
      emit('remove-selected', element)
      selected.value = true
      emit('label-click', element)
    }

    return {
      selected,
      expanded,
      toggle,
      labelClick
    }
  }
})
